/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { Text } from '@blend/enterprise-components';
import { Modal } from '@blend/enterprise-components';

import { ModalContent } from 'blb-components/ModalContent';
import { getPersona } from 'blb-persona/index';
import { MeContext } from 'blb-contexts/Me';
import { getSupportEmailAnchor, getSupportContactPhoneInfo } from 'blb-utils/contact';
export namespace HelpModal {
  export interface Props {
    handleClose: () => void;
    isOpen: boolean;
  }
}

export const HelpModal: React.FC<HelpModal.Props> = ({ isOpen, handleClose }) => {
  const me = React.useContext(MeContext)!;
  const persona = getPersona(me.principalType);
  const supportInfo = persona.getSupportContactInfo();

  return (
    <Modal contentLabel="Need Help?" handleClose={handleClose} isOpen={isOpen}>
      <ModalContent handleClose={handleClose} headerText="Need Help?">
        <Text>
          Contact {getSupportEmailAnchor(supportInfo.email)} {getSupportContactPhoneInfo(supportInfo)} if you need any
          help.
        </Text>
      </ModalContent>
    </Modal>
  );
};
